import { fetch } from '@atlassian/eoc-fetch';

import {
	type DashboardSpaces,
	type GetEmbedTokenResponse,
	type ReportSettings,
} from '../../common/types';
import { withReportingPrefix } from '../../common/utils';

import { type GetReportRightsResponse, type GetSsoEmbedUrlResponse } from './types';
import { opsReportsErrorTransformer as errorTransformer } from './utils';

export const getDashboards = () =>
	fetch<DashboardSpaces>(withReportingPrefix('/v5/reports/dashboards'), {
		exactUrl: true,
		errorTransformer,
	});

export const getDashboardsV3 = () =>
	fetch<DashboardSpaces>(withReportingPrefix('/v3/reports/dashboards'), {
		exactUrl: true,
		errorTransformer,
	});

export const getReportSettings = () =>
	fetch<ReportSettings>(withReportingPrefix('/v3/reports/index'), {
		exactUrl: true,
		errorTransformer,
	});

export const getSsoEmbedUrlEndpoint = (
	isDarkMode: boolean,
	dashboardId: string,
	teamId?: string | null,
) => {
	const queryParam: Record<string, string> = teamId
		? {
				theme: isDarkMode ? 'DarkMode' : '',
				dashboardId,
				teamId,
				// Adding time as queryParam to avoid browser caching
				// Should ideally be handled by "Cache-Control" header from server
				_: Date.now().toString(),
			}
		: {
				theme: isDarkMode ? 'DarkMode' : '',
				dashboardId: dashboardId,
				_: Date.now().toString(),
			};

	const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;

	return fetch<GetSsoEmbedUrlResponse>(withReportingPrefix(url), {
		exactUrl: true,
		errorTransformer,
	});
};

export const getReportRights = (teamId?: string | null) => {
	let url = '/v3/reports/rights';
	if (teamId) {
		url += `?teamId=${teamId}`;
	}

	return fetch<GetReportRightsResponse>(withReportingPrefix(url), {
		exactUrl: true,
		errorTransformer,
	});
};

export const getAVPEmbedTokens = (dashboardId: string, teamId: string) => {
	let url = '/v3/reports/embed-token';

	return fetch<GetEmbedTokenResponse>(withReportingPrefix(url), {
		exactUrl: true,
		method: 'POST',
		body: {
			dashboardId,
			teamId,
		},
		errorTransformer,
	});
};
